import { Link } from 'react-router-dom';

interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: string;
  rating: number;
  views: number;
  lastUpdated: string;
}

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000) {
      return (views / 10000).toFixed(1) + '万';
    }
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-2xl bg-background-50 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop=""
    >
      <div className="aspect-[3/4] overflow-hidden relative">
        <img
          src={comic.cover}
          alt={`${comic.title} - ${comic.author} - 韩漫漫画网`}
          title={`${comic.title} - ${comic.author}`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-accent-500/90 text-background-50'
              : 'bg-secondary-500/90 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-3 right-3 bg-primary-500/80 backdrop-blur-sm text-background-50 text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1 whitespace-nowrap">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1.5 truncate">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mb-2.5 whitespace-nowrap">
          {comic.author} · {formatViews(comic.views)}次阅读
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            更新至 {comic.lastUpdated}
          </span>
          <span className="text-xs text-accent-500 font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            立即阅读 <i className="ri-arrow-right-line text-[10px]"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}